import * as FileBrowserConstants from 'constants/FileBrowserConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as NavConstants from 'constants/NavConstants';
import {getSelectedPageSize} from 'nav/sidepanel/PageSizeUtil';
import * as FilterUtil from 'search/FilterUtil';
import {Filter, FilterKey, keyToEmptyFilter, Operator, SearchParams} from 'search/SearchConstants';
import * as SearchPreferences from 'search/SearchPreferences';
import * as SearchUtil from 'search/SearchUtil';

export const DEFAULT_TYPES_FILTER = {
  key: FilterKey.TYPES as const,
  operator: Operator.IS_ONE_OF,
  value: [
    ModelTypeConstants.CONTAINER,
    ModelTypeConstants.BOX,
    ModelTypeConstants.PLATE,
    ModelTypeConstants.LOCATION,
  ],
};

export const PRESERVED_FILTER_KEYS = [
  FilterKey.REGISTRY,
  FilterKey.PARENT_STORABLE,
  FilterKey.ANCESTOR_STORABLE,
];

export const LIST_ONLY_DEFAULT_FILTER_KEYS = [FilterKey.PARENT_STORABLE];

export function getDefaultStorablesSearchParams(registryId: string): SearchParams {
  return {
    filters: [
      DEFAULT_TYPES_FILTER,
      {
        ...keyToEmptyFilter(FilterKey.REGISTRY),
        value: registryId,
      },
      {
        ...keyToEmptyFilter(FilterKey.PARENT_STORABLE),
        value: FileBrowserConstants.FILTER_PARENT_STORABLE_ROOT,
      },
    ],
    limit: getSelectedPageSize(),
    offset: 0,
    query: '',
    sorts: SearchPreferences.getAppliedSortsFromUserPreference(NavConstants.Section.STORAGE),
  };
}

export function getListedStorableId(filters: Array<Filter>): string | null {
  const storableFilterValue = (FilterUtil.getFilterValueByKey(filters, FilterKey.PARENT_STORABLE) ||
    FilterUtil.getFilterValueByKey(filters, FilterKey.ANCESTOR_STORABLE)) as string | null;
  return storableFilterValue && storableFilterValue !== FileBrowserConstants.FILTER_PARENT_STORABLE_ROOT
    ? storableFilterValue
    : null;
}

export function resolveStorableFilter(searchParams: SearchParams): SearchParams {
  const shouldSearchDescendants = SearchUtil.hasQueryOrNonDefaultFilters(
    searchParams,
    PRESERVED_FILTER_KEYS,
    DEFAULT_TYPES_FILTER.value
  );
  const listedStorableId = getListedStorableId(searchParams.filters);
  let storableFilter = null;
  if (!listedStorableId) {
    if (shouldSearchDescendants) {
      storableFilter = null;
    } else {
      storableFilter = {
        ...keyToEmptyFilter(FilterKey.PARENT_STORABLE),
        value: FileBrowserConstants.FILTER_PARENT_STORABLE_ROOT,
      };
    }
  } else {
    // Use ANCESTOR_STORABLE for descendant search.
    storableFilter = {
      ...keyToEmptyFilter(shouldSearchDescendants ? FilterKey.ANCESTOR_STORABLE : FilterKey.PARENT_STORABLE),
      value: listedStorableId,
    };
  }
  const newFilters = searchParams.filters.filter(
    (filter) => ![FilterKey.PARENT_STORABLE, FilterKey.ANCESTOR_STORABLE].includes(filter.key)
  );
  if (storableFilter != null) {
    newFilters.push(storableFilter);
  }
  return {...searchParams, filters: newFilters};
}

export function hasQueryOrNonDefaultStorablesFilters(searchParams: SearchParams): boolean {
  return SearchUtil.hasQueryOrNonDefaultFilters(
    searchParams,
    PRESERVED_FILTER_KEYS,
    DEFAULT_TYPES_FILTER.value
  );
}
